(function($) {
  
  /* CARROSSEL DEPOIMENTOS INTERNET */
  
  $('.internet-evaluation-data-container').slick({
    dots: false,
    slidesToShow: 3,
    prevArrow: $('.internet-evaluation-action.prev'),
    nextArrow: $('.internet-evaluation-action.next'),
    responsive: [
    {
      breakpoint: 1030,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 780,
      settings: {
        slidesToShow: 1
      }
    }
  ]
  });
  
  /* CARROSSEL DICAS PERFECT */
  
 const dicas = $('.dicas-perfect .slider-container');

  if (dicas.length) {
    dicas.find('.slider-wrapper').slick({
      dots: false,
      slidesToShow: 3,
      prevArrow: dicas.find('.prev'),
      nextArrow: dicas.find('.next'),
      infinite: true,
      responsive: [
        {
          breakpoint: 1030,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 780,
          settings: {
            slidesToShow: 1,
            dots: true,
            appendDots: dicas.find('.container')
          }
        }
      ]
    });
  }

  
  /* CARROSSEL DEPOIMENTOS ENERGIA SOLAR */
  
  $('.solar-energy-evaluation-data-container').slick({
    dots: false,
    slidesToShow: 3,
    prevArrow: $('.solar-energy-evaluation-action.prev'),
    nextArrow: $('.solar-energy-evaluation-action.next'),
    responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 780,
      settings: {
        slidesToShow: 1
      }
    }
  ]
  });
  
  /* CARROSSEL DEPOIMENTOS TRABALHE CONOSCO */
  
  $('.trabalhe-conosco-evaluation-data-container').slick({
    dots: false,
    slidesToShow: 3,
    prevArrow: $('.trabalhe-conosco-evaluation-action.prev'),
    nextArrow: $('.trabalhe-conosco-evaluation-action.next'),
    responsive: [
    {
      breakpoint: 1365,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 975,
      settings: {
        slidesToShow: 1
      }
    }
  ]
  });
  
  
  /* CARROSSEL VAGAS TRABALHE CONOSCO */
  
  $('.vagas-disponiveis-content-data-container').slick({
    dots: false,
    slidesToShow: 2,
    prevArrow: $('.vagas-disponiveis-content-action.prev'),
    nextArrow: $('.vagas-disponiveis-content-action.next'),
    responsive: [
    {
      breakpoint: 1365,
      settings: {
        slidesToShow: 1
      }
    }
  ]
  });
  
  /* MAPA DE INTERNET */

  $(".internet-coverage-map-pin").mouseover(function() {
      $(".internet-coverage-map-pin-description-mobile").html($(this).children(".internet-coverage-map-pin-description").html());
      $(".internet-coverage-map-pin-description-mobile").css('display', 'flex');
  });
  
  $(".internet-coverage-map-pin").mouseout(function() {
      //$(".internet-coverage-map-pin-description-mobile").html($(this).html());
      $(".internet-coverage-map-pin-description-mobile").css('display', 'none');
  });
  
  /* CARROSSEL FUNCIONÁRIOS */
  
  $('.employees .data-container').slick({
    dots: false,
    slidesToShow: 5,
    prevArrow: $('.employees .action.prev'),
    nextArrow: $('.employees .action.next'),
    responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1
      }
    }
  ]
  });
  
})(jQuery);